import React from 'react'
import { Button } from '@ow/comps'
import Input from './Input'
import SendCode from './SendCode'
import Icon from './Icon'

export default ({ onBack, prefix, useLoginApi }) => {
  const {
    errors,
    registerUserName,
    registerPassword,
    registerRePassword,
    registerCode,
    usernameOk,
    passwordOk,
    rePasswordOk,
    getLoginCode,
    afterRegister,
  } = useLoginApi

  return (
    <form className={`${prefix}-loginBox register-box-${prefix}`}>
      <div
        className="rounded-full w-8 h-8 bg-white flex justify-center items-center cursor-pointer mt-10 back-btn"
        style={{
          boxShadow:
            '0 2px 16px 0 rgb(0 0 0 / 10%), 0 -1px 10px rgb(0 0 0 / 5%)',
        }}
        onClick={onBack}
      >
        <Icon
          width="16"
          color="#0056fe"
          path={[
            'M503.703033 813.56936c-46.207391-46.468334-92.579535-92.77601-138.987494-139.046846-53.253878-53.101405-106.60497-106.105596-162.03849-161.265894 13.256932-14.214746 23.925922-26.339902 35.311227-37.750789 86.790692-86.987167 173.759439-173.795255 260.556271-260.775258 9.230222-9.250688 19.21769-18.279319 26.194592-29.123294 10.748808-16.706497 10.456143-34.985816-3.816932-49.699935-15.835663-16.324804-35.003212-16.83748-53.399187-4.134157-9.326413 6.437619-17.176195 15.123442-25.275663 23.211654-102.015442 101.884458-204.051349 203.744357-305.866223 305.829384-44.690852 44.810578-44.806485 56.637951-1.131777 100.44569 101.798501 102.099353 203.788359 204.00837 305.814034 305.879526 9.239432 9.224082 18.576077 18.642592 29.14683 26.173103 17.025769 12.129248 34.276664 9.720386 49.094138-4.454452 14.995529-14.343683 16.262382-32.148188 6.736425-49.446156C520.664334 829.64857 511.74008 821.654502 503.703033 813.56936z',
            'M869.6404 470.26855c-8.143471-0.444115-16.32992-0.140193-24.495904-0.140193-140.471288-0.004093-280.941554-0.062422-421.411819 0.028653-53.994752 0.034792-75.130118 11.865235-73.347518 42.243103 1.815345 30.940686 18.49626 41.438785 75.477019 40.093137 70.195735-1.660826 140.461055-0.398066 210.695676-0.396019 24.50102 0.001023 49.002041 0.020466 73.502038-0.002047 53.900607-0.050142 107.821681 0.731664 161.696706-0.499373 33.139771-0.7552 50.351781-16.655332 49.539276-41.37227C920.488485 485.695914 903.026788 472.078779 869.6404 470.26855z',
          ]}
        />
      </div>

      <div
        className="font-semibold hidden lg:block"
        style={{ display: 'block', fontSize: '16px', marginTop: '30px' }}
      >
        注册账号
      </div>
      <div className={`${prefix}-inputGroupBox`} style={{ marginTop: '28px' }}>
        <Input
          prefix={prefix}
          register={registerUserName}
          title="手机号"
          hint="请输入手机号"
          name="userName"
          errMsg={errors && errors.userName ? errors.userName.message : ''}
          isPass={usernameOk}
          icon="M914.691674 123.697006H109.30935c-47.583643 0-86.289099 38.70648-86.2891 86.290123v603.998113c0 47.583643 38.705456 86.317752 86.2891 86.317752h805.382324c47.58262 0 86.288076-38.734109 86.288076-86.317752V209.987129c0-47.58262-38.705456-86.290123-86.288076-86.290123z m-15.169461 57.497414l-387.51505 335.861726-387.530399-335.861726h775.045449z m15.169461 661.581484H109.30935c-11.670784 0-21.62958-7.049542-26.138258-17.050293l274.221977-219.374921-35.955838-44.913843-240.893984 192.718871V219.283847l431.462893 373.892825L943.454707 219.283847v534.871871l-240.891938-192.718871-35.955838 44.913843L940.812535 825.724587c-4.491282 10.001775-14.49408 17.051317-26.120861 17.051317z"
        />
        <Input
          prefix={prefix}
          bgWhite
          isCode
          boderRaiusNone
          title="验证码"
          hint="请输入验证码"
          register={registerCode}
          name="code"
          errMsg={errors && errors.code ? errors.code.message : ''}
          icon="M511.92574 1023.975247C357.959389 1023.975247 71.50029 794.49855 71.50029 577.448076V163.162251c0-10.049894 8.416167-18.16902 18.837362-18.379424l24.95146-0.420808c0.953007 0 98.766196-1.967898 199.599304-41.895185 103.481725-40.843164 170.179849-87.936569 170.885322-88.419261l14.691162-10.421195a19.86463 19.86463 0 0 1 11.398956-3.601625 19.480951 19.480951 0 0 1 11.324696 3.539741l14.975826 10.507832c0.680719 0.482692 67.440727 47.526591 170.798685 88.419262 100.932121 39.927287 198.74531 41.895185 199.747825 41.895184l24.753432 0.420809c10.433572 0.210404 18.824985 8.32953 18.824986 18.379423l0.210404 414.285825c0 217.02572-286.508606 446.527171-440.6111 446.527171z m372.625797-812.568556c-37.860375-2.846645-117.516921-12.624251-200.267646-45.385419-84.557726-33.417134-146.725972-71.005221-172.358151-87.602398-25.557919 16.535293-87.763295 54.135757-172.296268 87.602398-82.602205 32.686908-162.03597 42.464514-200.416167 45.385419v366.041385c0 170.216979 249.576484 378.281957 372.712435 378.281957 47.724618 0 140.723264-38.726745 232.137691-123.767163 88.12222-81.909108 140.723264-177.07368 140.723264-254.490041z m-407.948946 435.660414a33.305744 33.305744 0 0 1-23.899439 10.049894 33.738929 33.738929 0 0 1-23.998453-10.037517l-101.674724-102.330691a34.345388 34.345388 0 0 1 0-48.269193 33.664668 33.664668 0 0 1 47.935022 0l77.738155 78.183717 196.269967-197.69329a33.590408 33.590408 0 0 1 47.910269 0 34.18449 34.18449 0 0 1 0 48.269194z m0 0"
        >
          <SendCode
            prefix={prefix}
            isRegister
            // disable={codeBtnDisabled}
            loginCodeApi={getLoginCode}
          />
        </Input>
        <Input
          prefix={prefix}
          bgWhite
          boderRaiusNone
          title="密码"
          hint="请输入密码"
          register={() => {
            return registerPassword(true)
          }}
          name="password"
          errMsg={errors && errors.password ? errors.password.message : ''}
          isPass={passwordOk}
          icon={[
            'M855.68 312.32h-55.68V288C800 129.28 670.72 0 512 0S224 129.28 224 288v23.68h-55.68C110.72 312.32 64 358.4 64 416v503.68c0 57.6 46.72 104.32 104.32 104.32h688c57.6 0 104.32-46.72 104.32-104.32V416c-0.64-57.6-47.36-103.68-104.96-103.68zM288 288C288 164.48 388.48 64 512 64s224 100.48 224 224v23.68h-448V288z m608 631.68c0 22.4-17.92 40.32-40.32 40.32H168.32c-22.4 0-40.32-17.92-40.32-40.32V416c0-22.4 17.92-40.32 40.32-40.32h688c21.76 0.64 39.68 18.56 39.68 40.32v503.68z',
            'M512 544c-17.92 0-32 14.08-32 32v128c0 17.92 14.08 32 32 32s32-14.08 32-32V576c0-17.92-14.08-32-32-32z',
          ]}
        />
        <Input
          prefix={prefix}
          bgWhite
          title="重复密码"
          hint="请再次输入密码"
          register={registerRePassword}
          name="rePassword"
          errMsg={errors && errors.rePassword ? errors.rePassword.message : ''}
          isPass={rePasswordOk}
          icon={[
            'M855.68 312.32h-55.68V288C800 129.28 670.72 0 512 0S224 129.28 224 288v23.68h-55.68C110.72 312.32 64 358.4 64 416v503.68c0 57.6 46.72 104.32 104.32 104.32h688c57.6 0 104.32-46.72 104.32-104.32V416c-0.64-57.6-47.36-103.68-104.96-103.68zM288 288C288 164.48 388.48 64 512 64s224 100.48 224 224v23.68h-448V288z m608 631.68c0 22.4-17.92 40.32-40.32 40.32H168.32c-22.4 0-40.32-17.92-40.32-40.32V416c0-22.4 17.92-40.32 40.32-40.32h688c21.76 0.64 39.68 18.56 39.68 40.32v503.68z',
            'M512 544c-17.92 0-32 14.08-32 32v128c0 17.92 14.08 32 32 32s32-14.08 32-32V576c0-17.92-14.08-32-32-32z',
          ]}
        />

        <div className="w-full flex items-center justify-between">
          <Button
            className={`${prefix}-loginBtn`}
            // disabled={checkRegisterDisabled()}
            onClick={afterRegister}
          >
            注册
          </Button>
          <Button
            className={`${prefix}-backBtn ml-2`}
            onClick={onBack}
          >
            返回
          </Button>
        </div>
      </div>
    </form>
  )
}
